import { InputBaseProps } from "@mui/material";
import * as dp from "@mui/x-date-pickers-pro";
import moment from "moment";
import { ReactNode } from "react";

export interface IDateTimePickerProps<TDate> extends dp.DateTimePickerProps<TDate> {
  name?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  children?: ReactNode;
  onBlur?: InputBaseProps['onBlur'];
}
const DateTimePicker = (props: IDateTimePickerProps<any>): JSX.Element => {
  return (
    <dp.DateTimePicker
      {...props}
      value={props.value ? moment(props.value) : null}
      minDate={props.minDate ? moment(props.minDate) : null}
      maxDate={props.maxDate ? moment(props.maxDate) : null}
      minDateTime={props.minDateTime ? moment(props.minDateTime) : null}
      maxDateTime={props.maxDateTime ? moment(props.maxDateTime) : null}
      onChange={(v, c) => {
        if (c.validationError)
          return;
        if (props.onChange)
          props.onChange({ target: { name: props.name, value: moment(v)?.format('yyyy-MM-DDTHH:mm') || null } }, c)
      }}
      slotProps={{
        textField: {
          helperText: props.helperText,
          error: props.error,
          required: props.required,
          name: props.name,
          variant: "outlined",
          fullWidth: true,
          InputLabelProps: { shrink: true },
          size: "small",
          onBlur: props.onBlur
        },
      }}
    />
  )
};

export default DateTimePicker;
